import React from "react";

const TiktokIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fill="#000"
      d="M11.25 0h2.476c.178.894.675 2.021 1.543 3.14C16.119 4.236 17.246 5 18.75 5v2.5c-2.192 0-3.839-1.017-5-2.286v8.536A6.25 6.25 0 1 1 7.5 7.5V10a3.75 3.75 0 1 0 3.75 3.75V0Z"
    />
  </svg>
);
export default TiktokIcon;
